import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../../provider/providerManager';

export const orderCallBack = createAsyncThunk('orderSuccess/orderCallBack', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('doCallBack', [data.id, data.phone, data.subjects]);
    return result.Body.isSuccess;
  } catch (error) {
    return error;
  }
});

const orderSuccessSlice = createSlice({
  name: 'orderSuccess',
  initialState: {
    success: false,
    isCallBackError: false,
  },

  reducers: {
    reportAnalytics: (state, action) => {},
  },

  extraReducers: {
    [orderCallBack.fulfilled]: (state, action) => {
      if (action.payload.errorCode != '00') {
        state.success = false;
        state.isCallBackError = true;
      } else {
        state.success = true;
        state.isCallBackError = false;
      }
    },
  },
});

export const {reportAnalytics} = orderSuccessSlice.actions;

export default orderSuccessSlice.reducer;
